let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jBnCj")).then(() => parcelRequire('9osvt'));